<template>
    <div class="hamburger-menu-panel">
        <div class="hamburger-menu">
            <a @click="hideOnClick" href="/">HOME</a>
            <a @click="hideOnClick" href="#aboutgame">THE GAME</a>
            <a @click="hideOnClick" href="https://www.facebook.com/lunarbasegame/">SOCIAL</a>
            <a @click="hideOnClick" href="https://shop.plepic.com">BUY</a>

        </div>
    </div>
</template>

<script>
    export default {
        name: "ham-menu",
        methods: {
            hideOnClick() {
                this.$store.commit("setHideMobileMenu")
            }
        },
        computed: {
            mobileMenuState() {
                return this.$store.state.showMobileMenu
            }
        }
    }
</script>
